import { useState } from 'react';
import { useFetchCallback } from '@services/services';
import toast from 'react-hot-toast';

interface RespondPayload {
  option_id: string;
  option_value?: string;
}

interface RespondResponse {
  message: string;
  response: {
    id: string;
    announcement_id: string;
    commerce_id: string;
    option_id: string;
    option_value: string;
    responded_at: string;
  };
  option: {
    label: string;
    value: string;
  };
}

export const useRespondAnnouncement = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { call } = useFetchCallback<RespondPayload, RespondResponse>('post', '/v1/announcement');

  const respond = async (announcementId: string, optionId: string, optionValue?: string) => {
    setIsSubmitting(true);
    try {
      const payload: RespondPayload = { option_id: optionId };
      if (optionValue) payload.option_value = optionValue;

      const response = await call({
        path: `${announcementId}/respond`,
        data: payload as RespondPayload & Record<string, unknown>,
      });
      return response;
    } catch {
      toast.error('Error al registrar tu respuesta');
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { respond, isSubmitting };
};
